module.exports = __webpack_public_path__ + "static/media/landing-mdec-image.b49f7b80.png";